import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 4px;
`

export const Description = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  color: ${myPalette.mutedText.main};
`

export const TitleNumberPayments = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
`

export const BlockWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

export const Block = styled.div`
  flex-direction: column;
  justify-content: center;
  padding: 8px 16px;
  display: flex;
  background: ${myPalette.white.main};
  font-size: 18px;
  border-radius: 12px;
  box-shadow: 0 0 5px 0 rgba(0, 21, 70, 0.1);
  margin-bottom: 20px;
  width: 100%;
`

export const BlockTitle = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
  margin-bottom: 4px;
`

export const BlockDescription = styled.div`
  font-size: 18px;
  font-weight: 500;
`

export const List = styled.div`
  font-size: 22px;
  background: ${myPalette.white.main};
  border: 1px solid ${myPalette.blue['500']};
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ListTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  padding: 4px 8px;
  background: ${myPalette.blue['500']};
`

export const ListItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 8px;
`

export const ListItem = styled.div`
  font-size: 16px;
`
